<ag-grid-angular
  class="user-management-grid ag-theme-alpine"
  [rowData]="rowData"
  [animateRows]="false"
  [defaultColDef]="defaultColDef"
  [columnDefs]="columnDefs"
  [getContextMenuItems]="getContextMenuItems"
  (gridReady)="onGridReady($event)"
  (cellValueChanged)="cellValueChanged($event)"
></ag-grid-angular>
<div class="user-management__bottom-area">
  <div class="user-management__bottom-area_buttons">
    <button (click)="addNewUser()" mat-raised-button color="primary">Add</button>
    <div>
      <button (click)="onSubmitChanges()" [disabled]="submitData.length === 0" mat-raised-button color="primary">Save</button>
      <button (click)="onCancelChanges()" mat-raised-button color="accent">Cancel</button>
    </div>
  </div>
</div>
